import { ROUTES } from '@/routes/Routes';

export const getGuestUrl = (meetingID: string, code: string) => {
  return `${window.location.origin}${ROUTES.LIVE_MEETING}?meeting=${meetingID}&guestUrlCode=${code}`;
};
